// Lets the /gems detail page hand a chosen Gem off to the chat surface across a
// navigation. Stored in sessionStorage so it survives an auth detour (login or
// guest sign-in) and is consumed once on /c. Tab-scoped — never persisted
// beyond the session, never logged.
//
// Mirrors `pending-prompt.ts`: the two are set together when a visitor taps a
// Gem starter question (gem + prompt), or alone when they just open the Gem.

const PENDING_GEM_KEY = 'sahib:pending-gem-slug';

export function getPendingGemSlug(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.sessionStorage.getItem(PENDING_GEM_KEY);
  } catch {
    return null;
  }
}

export function setPendingGemSlug(slug: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(PENDING_GEM_KEY, slug);
  } catch {
    // sessionStorage unavailable (private mode / quota) — silently degrade.
  }
}

export function clearPendingGemSlug(): void {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.removeItem(PENDING_GEM_KEY);
  } catch {
    // ignore
  }
}
